import {Store} from '@ngrx/store';
import {Injectable} from '@angular/core';
import {SettingsService} from '../../core/settings.service';
import * as fromPost from './store/post.reducers';
import {HttpClient, HttpParams} from '@angular/common/http';

@Injectable()
export class PostService {
  constructor(private httpClient: HttpClient,
              private settingsService: SettingsService,
              private store: Store<fromPost.State>) {
  }

  addPost(shortcode: string, params: any) {
    return this.httpClient.post(
      this.settingsService.getSetting('apiHost') + 'medias',
      {
        shortcode: shortcode
      }
    );
  }

  getPosts() {
    return this.httpClient.get(
      this.settingsService.getSetting('apiHost') + 'medias',
      {
        params: {

        }
      }
    );
  }

  getPost(id: number) {
    return this.httpClient.get(
      this.settingsService.getSetting('apiHost') + 'media/' + id
    );
  }

  getPostDetail(id: number) {
    return this.httpClient.get(
      this.settingsService.getSetting('apiHost') + 'media/' + id + '/detail'
    );
  }

  getPostProfileMedia(id: number) {
    return this.httpClient.get(
      this.settingsService.getSetting('apiHost') + 'media/' + id + '/profile/media'
    );
  }

  getPostProgress(id: number) {
    return this.httpClient.get(
      this.settingsService.getSetting('apiHost') + 'media/' + id + '/progress'
    );
  }

  getFollowerStat(id: number, type: number) {
    return this.httpClient.get(
      this.settingsService.getSetting('apiHost') + 'media/' + id + '/followers/' + type + '/stat'
    );
  }

  getMediaStat(id: number) {
    return this.httpClient.get(
      this.settingsService.getSetting('apiHost') + 'media/' + id + '/media/stat'
    );
  }

  getAudienceStat(id: number, type: number) {
    return this.httpClient.get(
      this.settingsService.getSetting('apiHost') + 'media/' + id + '/audiences/' + type + '/stat'
    );
  }

  getAudienceLocation(id: number, type: number) {
    return this.httpClient.get(
      this.settingsService.getSetting('apiHost') + 'media/' + id + '/audiences/' + type + '/location'
    );
  }

  getExportUsers(id: number, type: number) {
    const params: HttpParams = new HttpParams()
      .set('type', type.toString())
    ;
    return this.httpClient.get(
      this.settingsService.getSetting('apiHost') + 'media/' + id + '/export/rank',
      {
        params: params
      }
    );
  }
}
